// extracted by mini-css-extract-plugin
export var blue__btn = "style-module--blue__btn--85d27";
export var cost = "style-module--cost--3a515";
export var cost__bg = "style-module--cost__bg--72f39";
export var cost__blockBtn = "style-module--cost__block-btn--a88ee";
export var cost__col = "style-module--cost__col--90e68";
export var cost__colUnderblock = "style-module--cost__col-underblock--9fc09";
export var cost__colUnderblocks = "style-module--cost__col-underblocks--96c41";
export var cost__priceColor = "style-module--cost__price-color--896f1";
export var cost__priceOrange = "style-module--cost__price-orange--7f59a";
export var cost__priceText = "style-module--cost__price-text--3a0f7";
export var cost__row = "style-module--cost__row--a85c1";
export var cost__wrapper = "style-module--cost__wrapper--bf0a9";
export var orangeBtn = "style-module--orange-btn--540b5";
export var perMonth = "style-module--per-month--01fa7";